import { CircularProgress } from "@mui/material";
import React, { Fragment, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { clientStartLoading } from "../../actions/clientsActions";
import { ClientRouter } from "../../routes/ClientRouter";

import { ClientsTopbar } from "./components/ClientsTopbar";
import { useAppSelector } from "../../hooks";

export const ClientLayout = () => {
  const dispatch = useDispatch();
  const { uid } = useAppSelector((state) => state.authReducer.user);
  const { clientsIsLoading } = useSelector((state) => state.clients);

  useEffect(() => {
    dispatch(clientStartLoading(uid));
  }, [dispatch, uid]);

  return (
    <Fragment>
      <ClientsTopbar />
      <div className="l-clientsMain">
        <div className="container">
          {clientsIsLoading ? <CircularProgress /> : <ClientRouter />}
        </div>
      </div>
    </Fragment>
  );
};
